var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.846,
    height: 16.855,
    viewBox: "0 0 16.846 16.855",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M-150.021,538.286h-13.3l6.251-6.251a.8.8,0,0,0,0-1.137.8.8,0,0,0-1.136,0l-7.623,7.623a.817.817,0,0,0-.1.124c-.012.018-.021.038-.031.057a.824.824,0,0,0-.042.081.776.776,0,0,0-.024.079c-.007.024-.016.046-.021.071a.807.807,0,0,0,0,.314c0,.024.014.047.021.071s.014.053.025.079a.778.778,0,0,0,.042.08c.011.019.019.039.031.058a.821.821,0,0,0,.1.124l7.623,7.623a.8.8,0,0,0,.568.236.8.8,0,0,0,.568-.236.8.8,0,0,0,0-1.136l-6.251-6.252h13.3a.8.8,0,0,0,.8-.8A.8.8,0,0,0-150.021,538.286Z",
    transform: "translate(-149.217 547.517) rotate(180)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.dff14d64.svg";
export { ForwardRef as ReactComponent };